import React from 'react';

//shamelessly plagiarized from SolidJS: https://www.solidjs.com/tutorial/flow_show
export const Show: React.FC<{ when: boolean; fallback?: React.ReactNode; children: React.ReactNode }> = ({
  children,
  when,
  fallback = null,
}) => {
  if (!when) return <>{fallback}</>;
  return <>{children}</>;
};
